<template>
  <div>
    <b-modal
      :id="`create-${slicesType}-slices`"
      ref="slicingsModalRef"
      ok-only
      ok-title="Done"
      centered
      size="xl"
      :title="`Add ${slicesType} slices`"
      ok-variant="success"
      @ok="saveSlicings"
    >
      <b-card
        no-body
        class="p-1"
      >
        <validation-observer ref="slicingsRef">
          <b-row
            v-for="(slice, index) in timeSlices"
            :key="index"
          >
            <b-col md="3">
              <validation-provider
                name="From Time"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  :label="`From ${slicesType == 'distance' ? '(KM)': '(Minutes)'}`"
                  label-for="slicing-from"
                >
                  <b-form-input
                    id="slicing-from"
                    v-model.number="slice.from_unit"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <validation-provider
                name="To Time"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  :label="`To ${slicesType == 'distance' ? '(KM)': '(Minutes)'}`"
                  label-for="slicing-to"
                >
                  <b-form-input
                    id="slicing-to"
                    v-model.number="slice.to_unit"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="2">
              <validation-provider
                name="Amount"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Amount"
                  label-for="slicing-amount"
                >
                  <b-form-input
                    id="slicing-amount"
                    v-model.number="slice.amount"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="2">
              <b-form-group
                label="Fixed Slice"
                label-for="slicing-fixed"
              >
                <b-form-checkbox
                  :id="'slicing-fixed-' + index"
                  v-model="slice.is_fixed_slice"
                />

              </b-form-group>
            </b-col>
            <b-col
              md="2"
              class="d-flex align-items-center"
            >
              <b-button
                variant="primary"
                @click="deleteSlicing(index)"
              >
                Delete
              </b-button>
            </b-col>
          </b-row>
        </validation-observer>
        <b-col md="12">
          <b-button
            variant="success"
            @click="newSlice = true"
          >
            New Slice
          </b-button>
        </b-col>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BRow, BCol, BButton, BCard, BFormCheckbox,
} from 'bootstrap-vue'
import { computed, ref, watch } from '@vue/composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BCard,
    BModal,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BRow,
    BCol,
    BButton,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    slicesType: {
      type: String,
      default: 'time',
    },
    slicings: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const slices = ref(props.slicings ? props.slicings : [])
    const newSlice = ref(false)
    watch(() => props.slicings, () => {
      slices.value = props.slicings
    })
    const timeSlices = computed(() => {
      if (newSlice.value) {
        slices.value.push({
          from_unit: null,
          to_unit: null,
          amount: null,
          is_fixed_slice: null,
        })

        newSlice.value = false
      }

      return slices.value
    })

    const deleteSlicing = index => {
      slices.value.splice(index, 1)
    }
    const slicingsRef = ref(null)
    const slicingsModalRef = ref(null)

    const saveSlicings = async e => {
      try {
        e.preventDefault()
        const valid = await slicingsRef.value.validate()
        if (valid) {
          slicingsModalRef.value.hide()
          emit(`${props.slicesType}-slices`, slices.value)
        }
      } catch (error) {
        console.log(error)
      }
    }

    return {
      slices,
      newSlice,
      timeSlices,
      deleteSlicing,
      slicingsRef,
      slicingsModalRef,
      saveSlicings,
      required,
    }
  },
}
</script>
